<template>
  <div>
    <div class="text-right mt-4 mb-2">
      <span @click="inputAll()" class="cp" style="border-bottom: 2px dashed #888;">
        {{lg('',{
          en: 'Available',
          zh: '可用余额',
        })}}:
        {{num_balance | tofixed6 | qfw}}
      </span>
    </div>

    <!-- input block -->
    <div class="bg-sp2 p-3 d-flex" style="border-radius: 10px;">
      
      <div class="d-flex align-items-center">
        <span class="icon-sp mr-2">
          <img src="/static/img/icon_diamond_logo.png">
        </span>
        <span class="b i" style="font-size: 18px;">
          Diamond
        </span>
      </div>

      <input 
        v-model.number="form_num"
        class="ml flex-1 w-100 sp-transparent"
        type="text"
      >
    </div>

    <!--  -->
    <div class="mt-4">
      <div class="d-flex mb-2">
        <span>
          {{lg('',{
            en: 'Ratio',
            zh: '兑换比例',
          })}}
        </span>
        <span class="ml-auto">
          1 dJGN = 100 JGN
        </span>
      </div>

      <div class="d-flex mb-2">
        <span>
          {{lg('',{
            en: 'Receive',
            zh: '预计获得',
          })}}
        </span>
        <span class="ml-auto">
          {{ calc_receive | qfw }} JGN
        </span>
      </div>

      <div class="d-flex mb-2">
        <span>
          {{lg('',{
            en: 'Current Exit Fee Rate',
            zh: '退会费率',
          })}}
        </span>
        <span class="ml-auto">
          5%
        </span>
      </div>
    </div>

    <div class="tac py-4">
      <button
        @click="redeem()"
        class="btn btn-primary btn-lg px-5"
        :disabled="!form_num || form_num > num_balance"
        >
        {{lg('',{
          en: 'Redeem',
          zh: '赎回',
        })}}
        <span v-if="status_pendding" class="ui-dotting"></span>
      </button>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: 'formRedeem',
  components: {},
  props: [],
  data() {
    return {
      token_num_available: 0,

      form_num: '0',
      mark_balance_clicked: false,

      // redeem中
      status_pendding: false,

      num_balance: '-',
    }
  },
  computed: {
    calc_receive(){
      return this.form_num*100*0.95
    },
  },
  watch: {
    form_num(){
      this.mark_balance_clicked = false
    },
  },
  methods: {
    ...mapActions([
      'iLAVA_getiLavaBalance',
      'iLAVA_redeem',
    ]),

    inputAll(){
      
      this.form_num = (this.num_balance)
      setTimeout(() => {
        this.mark_balance_clicked = true
      }, 100);
    },
      
    async redeem(){
      let v = this
      let address_my = v.$store.state.web3.account

      v.status_pendding = true
      let form = {
        address: address_my,
        isAll: v.mark_balance_clicked ? true : false,
        lavaAmount: v.form_num,

        callback: function(){
          setTimeout(function(){
            v.status_pendding = false
            v.runClosest({
              vue: v,
              fn: 'toggleModal',
            })
            v.runClosest({
              vue: v,
              fn: 'run',
            })
          },3000)
        },
        callbackOnErr: function(){
          v.status_pendding = false
        }
      }
      
      await v.iLAVA_redeem(form)
      
    },

    async run(){
      // 获取 available 等数据
      let v = this

      if(!v.$store.state.web3.account){
        return
      }

      v.num_balance = await v.iLAVA_getiLavaBalance({
        address: v.$store.state.web3.account,
      })
    },
  },
  created() {
    this.run()
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  
</style>